import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Amplify } from 'aws-amplify'

import { App } from './App'
import { AuthProvider } from './context/AuthContext'
import './index.css'

const region = import.meta.env.VITE_AWS_REGION
const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
const userPoolClientId = import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID
const domain = import.meta.env.VITE_COGNITO_DOMAIN
const redirectSignIn = import.meta.env.VITE_REDIRECT_SIGN_IN
const redirectSignOut = import.meta.env.VITE_REDIRECT_SIGN_OUT
const authDisabled = import.meta.env.VITE_AUTH_DISABLED === 'true'

if (authDisabled) {
  console.info('[sim-monster] VITE_AUTH_DISABLED=true — running with stub user, no Cognito calls.')
} else if (!userPoolId || !userPoolClientId || !domain) {
  console.warn(
    '[sim-monster] Missing Cognito env vars and VITE_AUTH_DISABLED is not set. ' +
      'For local dev: set VITE_AUTH_DISABLED=true in web/.env.local. ' +
      'For prod: ./sm tf output -raw web_env_snippet > web/.env.production',
  )
} else {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [redirectSignIn ?? ''],
            redirectSignOut: [redirectSignOut ?? ''],
            responseType: 'code',
          },
        },
      },
    },
  })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)

console.info('[sim-monster] region=%s, region-name', region)
